import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";
import SignupForm from "../components/authPartials/SignupForm";
import ForgotPassword from "../components/authPartials/ForgotPassword";
import { useGeneral } from "../components/contexts/GeneralContext";

const ForgotPasswordPage = () => {
  const { discountCoupons } = useGeneral();
  return (
    <>
      <ScrollToTop />
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper className="">
          <ForgotPassword />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default ForgotPasswordPage;
